import { render, staticRenderFns } from "./IndividualJdModal.vue?vue&type=template&id=5c168f52&scoped=true&"
import script from "./IndividualJdModal.vue?vue&type=script&lang=js&"
export * from "./IndividualJdModal.vue?vue&type=script&lang=js&"
import style0 from "./IndividualJdModal.vue?vue&type=style&index=0&id=5c168f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c168f52",
  null
  
)

export default component.exports